import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from '../../ajs-upgraded-providers';
import { AnnotationConfig } from '../../annotations/shared/annotation-config';
import { AnnotatorConfig } from '../../annotations/shared/annotator-config';
import { Type } from '../../annotations/shared/Tools/annotator-tool';
import { DialogService } from '../../rl-common/dialogs/core/dialog.service';
import { CustomButton } from '../../rl-common/dialogs/shared/custom-button';
import { CustomDialogWindow } from '../../rl-common/dialogs/shared/custom-dialog-window';
import { RlFile } from '../../rl-common/file/shared/rl-file';
import { FormType } from '../../rl-common/forms/shared/form-type.enum';
import { DateService } from '../../rl-common/shared/core/date.service';
import { EntityType } from '../../rl-common/shared/shared/entity-type.enum';
import { AssignmentService } from '../core/assignment.service';
import { SubmissionService } from '../core/submission.service';
import { Assignment } from '../shared/assignment';
import { Submission } from '../shared/submission';

@Component({
  selector: 'rl-assignment-view',
  templateUrl: './assignment-view.component.html',
  styleUrls: ['./assignment-view.component.scss', './assignment-view.component-rtl.css']
})
export class AssignmentViewComponent implements OnInit {

  @Input('assignment') asgmt : Assignment;

  submission : Submission;
  asgmtFile : RlFile;
  edit : boolean;
  dueDateHasPassed : boolean;
  annotator : AnnotatorConfig;
  student : boolean = true;
  editFormType : FormType = FormType.ASSIGNMENT_INLINE;
  submitPopup : CustomDialogWindow;

  constructor(private assignmentService : AssignmentService, private submissionService : SubmissionService, private dialogService : DialogService,
    private dateService : DateService) { }

  ngOnInit(): void {
    this.annotator = this.submissionService.getAnnotationsConfig();

    this.student = !this.asgmt.owner;
    if(!this.student){
      this.asgmtFile = this.asgmt.file;
      return;
    }

    this.dueDateHasPassed = this.asgmt.dueDate && this.dateService.isDateBeforeToday(this.asgmt.dueDate);
    this.submissionService.loadUserSubmissionForAsgmt(this.asgmt.id).subscribe(s => {
      this.asgmtFile = this.asgmt.file;
      if(!s) return;
      this.submission = s;
      this.annotator.mainAnnotationConfig = new AnnotationConfig(s.id, EntityType.SUBMISSION);
      this.annotator.additionalAnnotationConfig = [new AnnotationConfig(this.asgmt.id, EntityType.ASSIGNMENT)];
      if(s.userSubmissionDate) this.disableAnnotationsTools();
      else{
        this.annotator.commentsPanelActions.push(new CustomButton('asgmt.view.submit', this.submit));
        this.annotator.commentsPanelMessages.push("subbmission.comments.auto.save");
      }
    });

    this.initSubmitPopup();
  }

  initSubmitPopup() {
    let confirmBtn = new CustomButton("btn.confirm", () => this.assignmentService.submit(this.submission).subscribe(s => window.location.reload()), "left")
    confirmBtn.main = true;

    this.submitPopup = new CustomDialogWindow("assignment.submit.areYouSure.title", "assignment.submit.areYouSure.msg");
    this.submitPopup.buttons = [confirmBtn, new CustomButton("btn.cancel")];
  }

  submit = () => this.dialogService.openDialog(this.submitPopup);
  
  disableAnnotationsTools = () => this.annotator.toolsDisabled.push(Type.comment, Type.shape);
}
